import { differenceInDays } from 'date-fns';

const GRACE_PERIOD_DAYS = 30;

const selectOutstanding = (state) => state.legal?.status?.outstanding || [];

const selectSatisfied = (state) => state.legal?.status?.satisfied || [];

const selectOrgOutstanding = (state) =>
  selectOutstanding(state).filter((o) => o.bundle !== 'user');

const selectUserOutstanding = (state) =>
  selectOutstanding(state).filter((o) => o.bundle === 'user');

const selectCatalogueItems = (state) => state.legal?.catalogue?.items || [];

const selectCatalogueItem = (state, documentKind) =>
  selectCatalogueItems(state).find((i) => i.documentKind === documentKind);

const selectIsUpdatedDoc = (state, documentKind) => {
  const satisfied = selectSatisfied(state);
  const outstanding = selectOutstanding(state);
  const hasSatisfied = satisfied.some((s) => s.documentKind === documentKind);
  const hasOutstanding = outstanding.some((o) => o.documentKind === documentKind);
  return hasSatisfied && hasOutstanding;
};

const selectGraceDaysRemaining = (state, documentKind) => {
  const catalogueItem = selectCatalogueItem(state, documentKind);
  if (!catalogueItem?.publishedAtIso) return 0;

  const publishedAt = new Date(catalogueItem.publishedAtIso);
  if (isNaN(publishedAt.getTime())) return 0;

  const daysSincePublish = differenceInDays(new Date(), publishedAt);
  return Math.max(0, GRACE_PERIOD_DAYS - daysSincePublish);
};

const selectHasAnyOutstanding = (state) => selectOutstanding(state).length > 0;

const selectIsAllFirstTime = (state, outstandingItems) =>
  outstandingItems.every((o) => !selectIsUpdatedDoc(state, o.documentKind));

const selectModalDismissable = (state, outstandingItems) => {
  if (outstandingItems.length === 0) return true;
  const allUpdates = outstandingItems.every((o) => selectIsUpdatedDoc(state, o.documentKind));
  if (!allUpdates) return false;
  return outstandingItems.some((o) => selectGraceDaysRemaining(state, o.documentKind) > 0);
};

const selectMinGraceDays = (state, outstandingItems) => {
  const updatedItems = outstandingItems.filter((o) => selectIsUpdatedDoc(state, o.documentKind));
  if (updatedItems.length === 0) return 0;
  return Math.min(...updatedItems.map((o) => selectGraceDaysRemaining(state, o.documentKind)));
};

export {
  selectOutstanding,
  selectSatisfied,
  selectOrgOutstanding,
  selectUserOutstanding,
  selectCatalogueItems,
  selectCatalogueItem,
  selectIsUpdatedDoc,
  selectGraceDaysRemaining,
  selectHasAnyOutstanding,
  selectIsAllFirstTime,
  selectModalDismissable,
  selectMinGraceDays,
};
